@switch (activeNavigationItem?.action) {

    @case ('dunningTypeTrigger') {
        <bm-dunning-type-trigger-data [dunningTypeTriggerId]="objectIdentifier.objectId"></bm-dunning-type-trigger-data>
    }

    @case ('dunningTypeTriggerLogicField') {
        <bm-dunning-type-trigger-logic-field [dunningTypeTriggerId]="objectIdentifier.objectId"></bm-dunning-type-trigger-logic-field>
    }

    @case ('dunningTypeLevelTriggerLogicField') {
        <bm-dunning-type-level-trigger-logic-field [dunningTypeTriggerId]="objectIdentifier.objectId"></bm-dunning-type-level-trigger-logic-field>
    }


    @default {
        <bm-dunning-type-trigger-data [dunningTypeTriggerId]="objectIdentifier.objectId"></bm-dunning-type-trigger-data>
    }
}
